// extracted by mini-css-extract-plugin
module.exports = {"contact":"Kontakt-module--contact--12xg7","furtherInformation":"Kontakt-module--further-information--22lg8","badge":"Kontakt-module--badge--a_hMd"};